var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.98438 0 0 8.98438 0 20C0 31.0938 8.98438 40 20 40C26.5625 40 32.4219 36.875 36.0156 32.0312C36.4844 31.4844 36.3281 30.7031 35.7812 30.3125C35.2344 29.8438 34.4531 30 34.0625 30.5469C30.8594 34.7656 25.7812 37.5 20 37.5C10.3906 37.5 2.5 29.6875 2.5 20C2.5 10.3906 10.3906 2.5 20 2.5C27.0312 2.5 33.0469 6.64062 35.8594 12.5H28.75C28.125 12.5 27.5 13.125 27.5 13.75C27.5 14.4531 28.125 15 28.75 15H38.75C39.4531 15 40 14.4531 40 13.75V3.75C40 3.125 39.4531 2.5 38.75 2.5C38.125 2.5 37.5 3.125 37.5 3.75V10.3125C34.1406 4.21875 27.5781 0 20 0ZM19.8672 11C20.4922 11 21.1172 11.625 21.1172 12.25V20.5312L26.9766 26.3906C27.4453 26.8594 27.4453 27.7188 26.9766 28.1875C26.5078 28.6562 25.6484 28.6562 25.1797 28.1875L18.9297 21.9375C18.6953 21.7031 18.5391 21.3906 18.5391 21V12.25C18.5391 11.625 19.1641 11 19.7891 11H19.8672Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgClock);
export default __webpack_public_path__ + "static/media/img_clock.c730ebbcd80299063971faa351562f08.svg";
export { ForwardRef as ReactComponent };